const articleContainer = document.querySelector('.js-article');

if (articleContainer != null) {
  const swiper = new Swiper('.js-article', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
}
